import { render, staticRenderFns } from "./selectFilm.vue?vue&type=template&id=4a246e90&scoped=true&"
import script from "./selectFilm.vue?vue&type=script&lang=js&"
export * from "./selectFilm.vue?vue&type=script&lang=js&"
import style0 from "./selectFilm.vue?vue&type=style&index=0&id=4a246e90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a246e90",
  null
  
)

export default component.exports